module.exports = __webpack_public_path__ + "f4c74eb7f80ab4cf238b61a021ea7fe9.woff2";